<div class="u-wrapper" [ngStyle]="!vm.isInitialized && {'min-height': '200px'}">
	<div class="c-card u-osb-md" *ngIf="vm.interview.triage">
		<div class="c-content c-content--lg c-content--s{{vm.level}}">
			<div class="o-grid o-grid--center-v">
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-pr u-no-p@up-to-md">
					<i class="o-icon o-icon--{{vm.icon}} c-text c-text--xl c-text--s4" aria-hidden="true"></i>
				</div>
				<div class="o-grid__cell">
					<h1 class="c-text c-text--heading c-text--s4 c-text--lg">{{vm.title}}</h1>
				</div>
			</div>
		</div>
		<div class="c-content c-content--lg">
			<div class="o-grid o-grid--column">
				<div class="o-grid__cell u-no-p@up-to-md">
					<p class="c-text c-text--spaced">{{vm.description}}</p>
				</div>
				<div class="o-grid__cell u-no-p@up-to-md" *ngIf="vm.isServiceAvailable">
					<div class="o-grid o-grid--center-h u-ost-lg">
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up u-no-p">
							<a id="talkToGpButton" [routerLink]="['/booking/instant']" [queryParams]="{category: 'GENERAL_MEDICAL_PRACTICE', interview: vm.interview.diagnosis.interview.localId, origin: vm.origin}" class="c-button c-button--s1 c-button--lg c-button--fit">{{vm.buttonText}}</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="c-card">
		<div class="o-grid" *ngIf="vm.isInitialized && vm.interview.diagnosis.conditions">
			<div class="o-grid__cell o-grid__cell--w-100 u-no-p@up-to-md">
				<div class="c-content c-content--lg">
					<h2 id="interviewResultsTitle" data-testid="symptom-interview-results" class="c-text c-text--heading c-text--lg">{{'Symptom_Check.Results.Title' | translate}}</h2>
					<p class="c-text" [innerHtml]="vm.generalDescription"></p>
					<div class="c-divider c-divider--h"></div>
					<div class="o-grid o-grid--wrap u-osb-sm" *ngFor="let condition of vm.interview.diagnosis.conditions ; let $index=index">
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-55@md-and-up u-no-p@up-to-md u-no-pl" [ngSwitch]="vm.hasTreatmentGuideline(condition.id)">
							<button id="treatmentGuideButton{{$index}}" type="button" class="c-button c-button--link u-text-left" *ngSwitchCase="true" (click)="vm.openTreatmentGuideline(condition.id)">
								{{condition.common_name}} {{'Symptom_Check.Results.Read_More' | translate}}
							</button>
							<p class="c-text" *ngSwitchDefault>{{condition.common_name}}</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-80 o-grid__cell--w-85@sm-and-up o-grid__cell--w-35@md-and-up u-no-p@up-to-md"
								 style="cursor: pointer" (click)="vm.openConditionInfo(condition)">
							<item-progress [value]="condition.probability" [max]="1"></item-progress>
						</div>
						<div id="conditionInfoButton{{$index}}" class="o-grid__cell o-grid__cell--w-20 o-grid__cell--w-15@sm-and-up o-grid__cell--w-10@md-and-up u-no-pr"
								 style="cursor: pointer" (click)="vm.openConditionInfo(condition)">
							<p class="c-text c-text--right">{{condition.probability * 100 | number: '1.1-1'}}%</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<loader-overlay data-testid="symptom-results-loading" *ngIf="!vm.isInitialized"></loader-overlay>
	<div id="stateCheckElementForAutomatedTests" *ngIf="vm.isInitialized"></div>
</div>
